import { State } from './state';
import { AuthState } from './auth/auth-state';
import { OrderState } from './order/order-state';
import { ShipmentState } from "./shipment/shipment-state";
import { KaskoState } from './kasko/kasko-state';
import { FinancingState } from './financing/financing-state';
import { DropshippingState } from './dropshipping/dropshipping-state';
import { RicondizionatoState } from './ricondizionato/ricondizionato-state';
export interface GenericContent {
  [key: string]: any;
}

export class AppState implements State {
  constructor(
    private _auth: AuthState = new AuthState(),
    private _order: OrderState = new OrderState(),
    private _shipment: ShipmentState = new ShipmentState(),
    private _kasko: KaskoState = new KaskoState(),
    private _financing: FinancingState = new FinancingState(),
    private _dropshipping: DropshippingState = new DropshippingState(),
    private _ricondizionato: RicondizionatoState = new RicondizionatoState()
  ) {
    this._auth = _auth.withParent(this);
    this._order = _order.withParent(this);
    this._shipment = _shipment.withParent(this);
    this._kasko = _kasko.withParent(this);
    this._financing = _financing.withParent(this);
    this._dropshipping = _dropshipping.withParent(this);
    this._ricondizionato = _ricondizionato.withParent(this);
  }

  get auth(): AuthState {
    return this._auth;
  }

  get order(): OrderState {
    return this._order;
  }

  get shipment(): ShipmentState {
    return this._shipment;
  }

  get kasko(): KaskoState {
    return this._kasko;
  }

  get financing(): FinancingState {
    return this._financing;
  }

  get dropshipping(): DropshippingState {
    return this._dropshipping;
  }

  get ricondizionato(): RicondizionatoState {
    return this._ricondizionato;
  }

  get initialized(): boolean {
    return this._auth.initialized;
  }

  withAuth(auth: AuthState): AppState {
    return new AppState(auth, this._order, this._shipment, this._kasko);
  }

  withOrder(order: OrderState): AppState {
    return new AppState(this._auth, order, this._shipment, this._kasko);
  }

  withShipment(shipment: ShipmentState): AppState {
    return new AppState(this._auth, this._order, shipment, this._kasko);
  }

  withKasko(kasko: KaskoState): AppState {
    return new AppState(this._auth, this.order, this._shipment, kasko);
  }

  withFinancing(financing: FinancingState): AppState {
    return new AppState(
      this._auth,
      this.order,
      this._shipment,
      this._kasko,
      financing
    );
  }

  withDropshipping(dropshipping: DropshippingState): AppState {
    return new AppState(
      this._auth,
      this.order,
      this._shipment,
      this._kasko,
      undefined,
      dropshipping,
      undefined
    );
  }

  withRicondizionato(ricondizionato: RicondizionatoState): AppState {
    return new AppState(
      this._auth,
      this.order,
      this._shipment,
      this._kasko,
      undefined,
      undefined,
      ricondizionato
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/state/state.module.ts